import React, { useContext, useEffect, useState } from "react";
import "../css/jobsheetView.scss";
import { hesLogo } from "../images/hesLogo";

import AccessTime from "@mui/icons-material/AccessTime";
import { useLocation } from "react-router-dom";
import { getDbRef } from "../helperFunctions/determineType";

import useTimesheet from "../customHooks/useTimesheet";
import IdentifierBar from "./IdentifierBar";
import Footer from "./Footer";
import { commentsMaterialTemplates, tooltips } from "../popData";
import { dateTimeFormatter } from "../helperFunctions/dateFormatters";
import { printSheet } from "../helperFunctions/printFunctions";
import { doc } from "firebase/firestore";
import { updatePrimary } from "../helperFunctions/primaryWrites";
import { SlidersContext } from "../providers/SlidersProvider";
import CloseIcon from "@mui/icons-material/Close";
import { calcJobsTotalCost, calcVat } from "../helperFunctions/calculationFunctions";
import { removeCardFees } from "../helperFunctions/pdfFunctions";

// Array of truthy value: for unerlines on back page on worksheet
let underlines = Array(49).fill(1);

let jds = [];

const JobsheetView = () => {
  let location = useLocation();
  let [formData, setFormData] = useState({});
  const { sliders, setSliderId } = useContext(SlidersContext);

  /* For convenience the current year is set to:
  - jobRecieved year date,
  - failing that, the current year
  - failing that, the string ----
  This does not save the year into the database but it is ok for our purposes.
  */
  const currentYear = dateTimeFormatter(formData?.jobReceived, "d_year_full", new Date().getFullYear());

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  let {
    // refNumber,
    // authorisedBy,
    // address,
    // address2,
    // email,
    // number,
    // worksOrderNumber,
    // jobDetails,
    // jobInBy = [],
    // phoneNumber,
    // orderNumber,
    // flat,
    // postcode,
    primaryType,
  } = location?.state?.timesheet;

  const [dbRef] = useState(getDbRef(primaryType));
  const timesheet = useTimesheet(dbRef, location.state.timesheet.uid);

  const [primaryDocRef] = useState(doc(dbRef, location.state.timesheet.uid));

  useEffect(() => {
    setFormData(timesheet);
  }, [timesheet]);

  // function formatFlat() {
  //   if (!flat) return ["", ""];
  //   else {
  //     let splitFlat = flat.split("/");

  //     return splitFlat;
  //   }
  // }

  // function worksOrderView() {
  //   history.push(`/timesheet/worksOrderView`, { timesheet, jobDescriptions });
  // }

  const inputHandler = (e) => {
    let name = e.target.name;
    let value = e.target.value;

    if (name === "postcode") {
      value = value.toUpperCase();
    }

    setFormData({ ...formData, [name]: value });
    // query.update({ [name]: value });
  };

  const saveInput = (e) => {
    let name = e.target.name;
    let value = e.target.value;

    if (name === "paid" || name === "sent" || name === "cert") {
      value = e.target.checked;
    } else {
      // trim inputs on save
      value = value.trim();
    }

    updatePrimary(primaryDocRef, { [name]: value });
  };

  function fillInJobLocation() {
    // console.log("Form dta", formData);

    updatePrimary(primaryDocRef, {
      jobLocation: formData?.address ?? "",
      jobLocation2: formData?.address2 ?? "",
      jobLocation3: formData?.address3 ?? "",
      jobLocationCity: formData?.city ?? "",
      jobLocationFlat: formData?.flat ?? "",
      jobLocationPostcode: formData?.postcode ?? "",
    });
  }

  function fillInTodaysDate(e, quoteField) {
    let today = new Date();
    const formattedDate = dateTimeFormatter(today, "d_full");
    let [day, month, year] = formattedDate.split("/");

    let quoteDay = `${quoteField}Day`;
    let quoteMonth = `${quoteField}Month`;
    let quoteYear = `${quoteField}Year`;

    updatePrimary(primaryDocRef, {
      [quoteDay]: day,
      [quoteMonth]: month,
      [quoteYear]: year,
    });
  }

  function fillInQuoteAmount() {
    // Populate quote amount box with total cost of job (with card fees removed)
    let jdsWithFeesRemoved = removeCardFees(location.state?.jobDescriptions);
    let cost = calcJobsTotalCost(jdsWithFeesRemoved, formData?.vatMode)[4];
    const [vatCost, inc] = calcVat(cost, formData?.vatMode);

    let formattedCost = `£${inc}`;

    updatePrimary(primaryDocRef, {
      quoteAmount: formattedCost,
    });
  }

  function handleJobBy(e) {
    let name = e.target.name;
    let checked = e.target.checked;
    let today = new Date();
    let [day, time] = dateTimeFormatter(today, "dt_short_variant").split("/");

    setFormData({
      ...formData,
      jobInBy: { ...formData?.jobInBy, [name]: checked },
    });

    // Fill in todays dates in job receieved section
    fillInTodaysDate(e, "jobsheetDate");

    // Update db with job received method, time and day.
    updatePrimary(primaryDocRef, {
      jobInBy: { ...formData?.jobInBy, [name]: checked },
      jobsheetDateTime: time,
      jobsheetReceivedDay: day,
    });
  }

  function calculateCardFee() {
    // When user selects card fee payment option
    // The card fee needs to be retrieved from the
    // set prices list of the job descriptions and
    // displayed in the card fee box.
    if (formData.paymentMethod !== "card") {
      return "";
    }

    if (location?.state?.jobDescriptions) {
      let { jobDescriptions } = location.state;

      let cardFees = [];
      jobDescriptions.forEach(({ setPriceList = [] }) => {
        // console.log("Jd is", jd);
        setPriceList.forEach((setPrice) => {
          if (setPrice?.name === "Card Fee") {
            cardFees.push(setPrice.price);
          }
        });
      });

      let totalFee = cardFees.reduce((total, fee) => {
        return (total += Math.abs(fee));
      }, 0);

      return `£${Number(totalFee).toFixed(2)}`;
    } else {
      return "";
    }
  }

  function handleAddTemplate(mTemplate) {
    let prefix = "";
    let currentComments = formData?.comments2;

    if (currentComments) {
      // if comments have already been inputted
      prefix = `${formData?.comments2}\n`;
    }

    let newComments = `${prefix}${mTemplate.text}`;

    updatePrimary(primaryDocRef, { comments2: newComments });
  }

  function clearTemplateText() {
    updatePrimary(primaryDocRef, { comments2: "" });
  }

  return (
    <div id="section-to-print" className={`${sliders ? "" : "shrink"} jobsheetViewContainer`}>
      <IdentifierBar title="Jobsheet" callbacks={[{ name: "PRINT", cb: printSheet }]} back={true} />

      <Footer title={"Jobsheet"} back={true}>
        {sliders && (
          <>
            <button
              title={tooltips.closeSlider}
              className="adder slider-control"
              onClick={() => setSliderId(null)}
            >
              <CloseIcon style={{ fontSize: 28 }} />
            </button>
          </>
        )}

        {/* <button
          onClick={() => {
            toggleSendbar(false);
            toggleToolbar((state) => !state);
          }}
          className="adder"
        >
          <BuildIcon />
        </button>
        <button
          onClick={() => {
            toggleToolbar(false);

            toggleSendbar((state) => !state);
          }}
          className="adder"
        >
          {sending ? <HourglassEmptyIcon /> : <MailOutlineIcon />}
        </button> */}
      </Footer>
      <div className="jobsheetViewPage1">
        <div className="header">
          <img className="header" alt="Henderson Electrical Services logo" src={hesLogo} />

          <h2 className="title">JOB SHEET</h2>

          <div className="date-box">
            <div className="date-row-1">
              <div className="day">
                <h3>DAY</h3>
                <div>
                  <span>{dateTimeFormatter(formData?.bookedInDateTime, "d_day_short")}</span>
                  <span>{dateTimeFormatter(formData?.bookedInDateTime, "d_short")}</span>
                </div>
              </div>
              <div className="job">
                <h3>JOB</h3>
                <div>
                  <input
                    id="jobDayOrderNumber"
                    name="jobDayOrderNumber"
                    type="text"
                    value={formData?.jobDayOrderNumber ?? ""}
                    onChange={inputHandler}
                    onBlur={saveInput}
                    // className="qte-number-input"
                    // onFocus={inputHandler}
                    // onBlur={inputHandler}
                  />
                </div>
              </div>
            </div>
            <div className="date-row-2">
              <AccessTime className="time-icon" />
              <p className="time-input" contentEditable={false}>
                {dateTimeFormatter(formData?.bookedInDateTime, "t_short")}
              </p>
              <p className="am-pm">am / pm</p>
            </div>
          </div>
        </div>

        <div className="row-1">
          <div className="customer-group">
            <div className="customer-header">
              <span>CUSTOMER DETAILS</span>
              <div className="qte-box">
                <span className="c-label-1">SRN:</span>
                <div className="qte-number">
                  <input
                    id="worksOrderNumber"
                    name="worksOrderNumber"
                    type="text"
                    value={formData?.worksOrderNumber ?? ""}
                    onChange={inputHandler}
                    onBlur={saveInput}
                    className="qte-number-input"
                    // onFocus={inputHandler}
                    // onBlur={inputHandler}
                  />
                  {/* <p contentEditable={false} className="qte-number-input">
                    {formData?.worksOrderNumber ?? ""}
                  </p> */}
                </div>
                <div className="qte-sent-date">
                  <span className="qte-sent-label">Sent</span>
                  <div className="qte-sent-inputs">
                    <p contentEditable={false} className="date-input"></p>
                    <span>/</span>
                    <p contentEditable={false} className="date-input"></p>
                    <span>/</span>
                    <p contentEditable={false} className="date-input">
                      {currentYear}
                    </p>
                  </div>
                </div>
              </div>
              <div className="hes-number-box">
                <span className="c-label-1">HES No: </span>
                <div className="hes-number">
                  <input
                    onChange={inputHandler}
                    type="text"
                    id="refNumber"
                    name="refNumber"
                    value={formData?.refNumber ?? ""}
                    className="hes-number-input"
                    onBlur={saveInput}
                  />
                  {/* <p contentEditable={false} className="hes-number-input">
                    {refNumber}
                  </p> */}
                </div>
              </div>
            </div>

            <div className="customer-general-details">
              <div className="customer-details-1">
                <div className="c-line">
                  <span className="c-label-2">Customer Name</span>

                  <input
                    onChange={inputHandler}
                    type="text"
                    id="authorisedBy"
                    name="authorisedBy"
                    value={formData?.authorisedBy ?? ""}
                    className="customer-name-input"
                    onBlur={saveInput}
                  />
                  {/* <input defaultValue={authorisedBy} /> */}
                </div>
                <div className="c-line">
                  <span className="c-label-2">SRN</span>
                  <input
                    // id="worksOrderNumber"
                    name="worksOrderNumber"
                    type="text"
                    value={formData?.worksOrderNumber ?? ""}
                    onChange={inputHandler}
                    onBlur={saveInput}

                    // onFocus={inputHandler}
                    // onBlur={inputHandler}
                  />
                  {/* <input
                    defaultValue={orderNumber}
                    className="order-number-input"
                  /> */}
                </div>
                <div className="c-line">
                  <span className="c-label-2">Mobile</span>
                  <input
                    id="number"
                    name="number"
                    type="text"
                    autoComplete="off"
                    value={formData?.number ?? ""}
                    onChange={inputHandler}
                    onBlur={saveInput}

                    // onFocus={inputHandler}
                    // onBlur={inputHandler}
                  />
                  {/* <input defaultValue={number} className="mobile-input" /> */}
                </div>
                <div className="c-line">
                  <span className="c-label-2">Phone</span>
                  {/* <input defaultValue={phoneNumber} className="phone-input" /> */}
                  <input
                    id="homeNumber"
                    name="homeNumber"
                    type="text"
                    autoComplete="off"
                    value={formData.homeNumber ?? ""}
                    onChange={inputHandler}
                    onBlur={saveInput}

                    // onFocus={inputHandler}
                    // onBlur={inputHandler}
                  />
                </div>
              </div>
              <div className="customer-details-2">
                <div className="customer-address">
                  <span className="c-label-2">Address</span>

                  <input
                    id="address"
                    name="address"
                    autoComplete="off"
                    type="text"
                    value={formData?.address ?? ""}
                    onChange={inputHandler}
                    onBlur={saveInput}
                    className="address-input l1"
                    // onFocus={inputHandler}
                    // onBlur={inputHandler}
                  />

                  <input
                    id="address2"
                    name="address2"
                    autoComplete="off"
                    type="text"
                    value={formData?.address2 ?? ""}
                    onChange={inputHandler}
                    onBlur={saveInput}
                    className="address-input l2"
                    // onFocus={inputHandler}
                    // onBlur={inputHandler}
                  />

                  <input
                    id="address3"
                    name="address3"
                    autoComplete="off"
                    type="text"
                    value={formData?.address3 ?? ""}
                    onChange={inputHandler}
                    onBlur={saveInput}
                    className="address-input l3"
                    // onFocus={inputHandler}
                    // onBlur={inputHandler}
                  />

                  <input
                    id="city"
                    name="city"
                    autoComplete="off"
                    type="text"
                    value={formData?.city ?? ""}
                    onChange={inputHandler}
                    onBlur={saveInput}
                    className="address-input l4"
                    // onFocus={inputHandler}
                    // onBlur={inputHandler}
                  />

                  <div className="flat-input-group">
                    <span>Flat </span>
                    <input
                      id="flat"
                      name="flat"
                      type="text"
                      autoComplete="off"
                      value={formData?.flat ?? ""}
                      onChange={inputHandler}
                      onBlur={saveInput}
                      className="flat-input"

                      // onFocus={inputHandler}
                      // onBlur={inputHandler}
                    />
                  </div>

                  <div className="postcode-input-group">
                    <input
                      id="postcode"
                      name="postcode"
                      type="text"
                      autoComplete="off"
                      value={formData?.postcode ?? ""}
                      onChange={inputHandler}
                      onBlur={saveInput}
                      className="postcode-input"
                      // onFocus={inputHandler}
                      // onBlur={inputHandler}
                    />
                    {/* <span>G </span>

                    <p
                      contentEditable={false}
                      className={`address-input p1`}
                    ></p>
                    <p
                      contentEditable={false}
                      className={`address-input p2`}
                    ></p> */}
                  </div>
                </div>
                <div className="customer-email">
                  <span className="c-label-2">email</span>
                  <input
                    id="email"
                    name="email"
                    autoComplete="off"
                    type="text"
                    value={formData?.email ?? ""}
                    onChange={inputHandler}
                    onBlur={saveInput}
                    className="email-input"
                    // onFocus={inputHandler}
                    // onBlur={inputHandler}
                  />
                  {/* <p contentEditable={false} className="email-input">
                    {email}
                  </p> */}
                </div>
              </div>
            </div>

            <div className="send-details-group">
              <div className="send-time-group">
                <div className="send-checks">
                  {/* <div className="s-check">
                    <label htmlFor="byTel" className="s-label">
                      Tel
                    </label>
                    <input
                      className={`s-circle`}
                      type="checkbox"
                      name="byTel"
                      id="byTel"
                    />
                  </div>
                  <div className="s-check">
                    <label htmlFor="byTel" className="s-label">
                      Qte
                    </label>
                    <input
                      className={`s-circle`}
                      type="checkbox"
                      name="byQte"
                      id="byQte"
                    />
                  </div>
                  <div className="s-check">
                    <label htmlFor="byText" className="s-label">
                      Text
                    </label>
                    <input
                      className={`s-circle`}
                      type="checkbox"
                      name="byText"
                      id="byText"
                    />
                  </div>
                  <div className="s-check">
                    <label htmlFor="byEmail" className="s-label">
                      Email
                    </label>
                    <input
                      className={`s-circle`}
                      type="checkbox"
                      name="byEmail"
                      id="byEmail"
                    />
                  </div> */}

                  <div className="s-check">
                    <p className="s-label">Tel</p>
                    <div className={`s-circle`}>
                      <input
                        type="checkbox"
                        name="byTel"
                        id="byTel"
                        onChange={handleJobBy}
                        checked={formData?.jobInBy?.byTel || false}
                      />
                    </div>
                  </div>
                  {/* <div className="s-check">
                    <p className="s-label">Qte</p>
                    <div className={`s-circle`}>
                    <input
                        type="checkbox"
                        name="byQte"
                        id="byQte"
                        onChange={handleJobBy}
                        value={formData?.jobInBy === "qte"}
                      />
                    </div>
                  </div> */}
                  <div className="s-check">
                    <p className="s-label">Text</p>
                    <div className={`s-circle`}>
                      <input
                        type="checkbox"
                        name="byText"
                        id="byText"
                        onChange={handleJobBy}
                        checked={formData?.jobInBy?.byText || false}
                      />
                    </div>
                  </div>
                  <div className="s-check">
                    <p className="s-label">Email</p>
                    <div className={`s-circle`}>
                      <input
                        type="checkbox"
                        name="byEmail"
                        id="byEmail"
                        onChange={handleJobBy}
                        checked={formData?.jobInBy?.byEmail || false}
                      />
                    </div>
                  </div>
                </div>
                <div className="time-boxes">
                  <div className="qte-day">
                    <span className="qte-label-1">Day:</span>
                    <input
                      onChange={inputHandler}
                      type="text"
                      id="jobsheetReceivedDay"
                      name="jobsheetReceivedDay"
                      value={formData?.jobsheetReceivedDay ?? ""}
                      className="s-t-input"
                      onBlur={saveInput}
                    />
                    {/* <p contentEditable={false} className={`s-t-input`}></p> */}
                  </div>
                  <div className="qte-date">
                    <span className="qte-label-1">Date:</span>
                    <div className="s-t-date-inputs">
                      <input
                        onChange={inputHandler}
                        type="text"
                        id="jobsheetDateDay"
                        name="jobsheetDateDay"
                        value={formData?.jobsheetDateDay ?? ""}
                        className="d-input"
                        onBlur={saveInput}
                      />
                      {/* <p contentEditable={false} className={`d-input`}></p> */}
                      <span>/</span>
                      <input
                        onChange={inputHandler}
                        type="text"
                        id="jobsheetDateMonth"
                        name="jobsheetDateMonth"
                        value={formData?.jobsheetDateMonth ?? ""}
                        className="d-input"
                        onBlur={saveInput}
                      />
                      {/* <p contentEditable={false} className={`d-input`}></p> */}
                      <span>/</span>
                      <input
                        onChange={inputHandler}
                        type="text"
                        id="jobsheetDateYear"
                        name="jobsheetDateYear"
                        value={formData?.jobsheetDateYear ?? currentYear}
                        className="d-input"
                        onBlur={saveInput}
                      />
                      {/* <p contentEditable={false} className={`d-input`}>
                        2022
                      </p> */}
                    </div>
                  </div>
                  <div className="qte-time">
                    <span className="qte-label-1">Time:</span>
                    <p contentEditable={false} className={`s-t-input`}></p>
                    <input
                      onChange={inputHandler}
                      type="text"
                      id="jobsheetDateTime"
                      name="jobsheetDateTime"
                      value={formData?.jobsheetDateTime ?? ""}
                      className="s-t-input"
                      onBlur={saveInput}
                    />
                  </div>
                </div>
              </div>

              <div className="qte-deets-group">
                <div className="qte-deets-header">
                  <span>QUOTATION DETAILS</span>
                </div>
                <div className="qte-deets-boxes">
                  <div className="qte-no">
                    <span className="qte-label-2">SRN:</span>
                    <input
                      // id="worksOrderNumber"
                      name="worksOrderNumber"
                      type="text"
                      className="s-t-input"
                      value={formData?.worksOrderNumber ?? ""}
                      onChange={inputHandler}
                      onBlur={saveInput}

                      // onFocus={inputHandler}
                      // onBlur={inputHandler}
                    />
                    {/* <p contentEditable={false} className={`s-t-input`}></p> */}
                  </div>
                  <div className="qte-sent">
                    <span className="qte-label-2">
                      <button onClick={(e) => fillInTodaysDate(e, "quoteSent")}>Quote Sent:</button>
                    </span>
                    <div className="s-t-date-inputs">
                      <input
                        onChange={inputHandler}
                        type="text"
                        id="quoteSentDay"
                        name="quoteSentDay"
                        value={formData?.quoteSentDay ?? ""}
                        className="d-input"
                        onBlur={saveInput}
                      />
                      {/* <p contentEditable={false} className={`d-input`}></p> */}
                      <span>/</span>
                      <input
                        onChange={inputHandler}
                        type="text"
                        id="quoteSentMonth"
                        name="quoteSentMonth"
                        value={formData?.quoteSentMonth ?? ""}
                        className="d-input"
                        onBlur={saveInput}
                      />
                      <span>/</span>
                      <input
                        onChange={inputHandler}
                        type="text"
                        id="quoteSentYear"
                        name="quoteSentYear"
                        value={formData?.quoteSentYear ?? currentYear}
                        className="d-input"
                        onBlur={saveInput}
                      />

                      {/* <p contentEditable={false} className={`d-input`}></p>
                      <span>/</span>
                      <p contentEditable={false} className={`d-input`}></p>
                      <span>/</span>
                      <p contentEditable={false} className={`d-input`}>
                        2022
                      </p> */}
                    </div>
                  </div>
                  <div className="qte-amount">
                    <span className="qte-label-2">
                      <button onClick={fillInQuoteAmount}>Quote Amount:</button>
                    </span>

                    <input
                      // id="worksOrderNumber"
                      name="quoteAmount"
                      id="quoteAmount"
                      type="text"
                      className="s-t-input"
                      value={formData?.quoteAmount ?? ""}
                      onChange={inputHandler}
                      onBlur={saveInput}

                      // onFocus={inputHandler}
                      // onBlur={inputHandler}
                    />
                  </div>
                  <div className="qte-accepted">
                    <span className="qte-label-2">
                      {" "}
                      <button onClick={(e) => fillInTodaysDate(e, "quoteAccepted")}>
                        Quote Accepted:
                      </button>
                    </span>
                    <div className="s-t-date-inputs">
                      <input
                        onChange={inputHandler}
                        type="text"
                        id="quoteAcceptedDay"
                        name="quoteAcceptedDay"
                        value={formData?.quoteAcceptedDay ?? ""}
                        className="d-input"
                        onBlur={saveInput}
                      />
                      <span>/</span>
                      <input
                        onChange={inputHandler}
                        type="text"
                        id="quoteAcceptedMonth"
                        name="quoteAcceptedMonth"
                        value={formData?.quoteAcceptedMonth ?? ""}
                        className="d-input"
                        onBlur={saveInput}
                      />
                      <span>/</span>
                      <input
                        onChange={inputHandler}
                        type="text"
                        id="quoteAcceptedYear"
                        name="quoteAcceptedYear"
                        value={formData?.quoteAcceptedYear ?? currentYear}
                        className="d-input"
                        onBlur={saveInput}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="writing-block">
              <p className="header">Brief Job Details</p>
              <div className="multi-line-notes">
                {/* <textarea
                  className="block-writing-input"
                  defaultValue={jobDetails}
                /> */}
                <textarea
                  id="jobDetails"
                  name="jobDetails"
                  rows={2}
                  value={formData?.jobDetails ?? ""}
                  onChange={inputHandler}
                  onBlur={saveInput}
                  className="block-writing-input"
                  // value={formData.jobDetails ?? ""}
                  // onFocus={inputHandler}
                  // onBlur={inputHandler}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="row-2">
          <div className="comments-group">
            <div className="writing-block">
              <p className="header">Comments</p>
              <div className="multi-line-notes">
                {/* <textarea className="block-writing-input" /> */}
                <textarea
                  id="comments"
                  name="comments"
                  rows={2}
                  value={formData?.comments ?? ""}
                  onChange={inputHandler}
                  onBlur={saveInput}
                  className="block-writing-input comments"
                  // value={formData.jobDetails ?? ""}
                  // onFocus={inputHandler}
                  // onBlur={inputHandler}
                />
                <textarea
                  id="comments2"
                  name="comments2"
                  rows={2}
                  value={formData?.comments2 ?? ""}
                  onChange={inputHandler}
                  onBlur={saveInput}
                  className="block-writing-input comments2"
                />

                <div className="quickTemplates">
                  {commentsMaterialTemplates.map((mTemplate, i) => {
                    return (
                      <button key={i} onClick={() => handleAddTemplate(mTemplate)}>
                        {mTemplate.name}
                      </button>
                    );
                  })}
                  <button onClick={clearTemplateText}>Clear</button>
                </div>
              </div>
            </div>
          </div>

          <div className="job-access-group">
            <div className="job-location-group">
              <div className="writing-block">
                <p className="header">Job Location</p>
                <div className="job-location-inputs">
                  <span className="jl-label-1">Address</span>
                  <button className="sameAs" onClick={fillInJobLocation}>
                    same as address
                  </button>

                  <input
                    id="jobLocation"
                    name="jobLocation"
                    autoComplete="off"
                    type="text"
                    value={formData?.jobLocation ?? ""}
                    onChange={inputHandler}
                    onBlur={saveInput}
                    className="address-input l1"
                    // onFocus={inputHandler}
                    // onBlur={inputHandler}
                  />

                  <input
                    id="jobLocation2"
                    name="jobLocation2"
                    autoComplete="off"
                    type="text"
                    value={formData?.jobLocation2 ?? ""}
                    onChange={inputHandler}
                    onBlur={saveInput}
                    className="address-input l2"
                    // onFocus={inputHandler}
                    // onBlur={inputHandler}
                  />

                  <input
                    id="jobLocation3"
                    name="jobLocation3"
                    autoComplete="off"
                    type="text"
                    value={formData?.jobLocation3 ?? ""}
                    onChange={inputHandler}
                    onBlur={saveInput}
                    className="address-input l3"
                    // onFocus={inputHandler}
                    // onBlur={inputHandler}
                  />

                  <input
                    id="jobLocationCity"
                    name="jobLocationCity"
                    autoComplete="off"
                    type="text"
                    value={formData?.jobLocationCity ?? ""}
                    onChange={inputHandler}
                    onBlur={saveInput}
                    className="address-input l4"
                    // onFocus={inputHandler}
                    // onBlur={inputHandler}
                  />

                  <div className="flat-input-group">
                    <span>Flat </span>
                    <input
                      id="jobLocationFlat"
                      name="jobLocationFlat"
                      type="text"
                      autoComplete="off"
                      value={formData?.jobLocationFlat ?? ""}
                      onChange={inputHandler}
                      onBlur={saveInput}
                      className="flat-input"

                      // onFocus={inputHandler}
                      // onBlur={inputHandler}
                    />
                  </div>

                  {/* <p contentEditable={false} className="address-input l1"></p>
                  <p contentEditable={false} className={`address-input l2`}></p>
                  <p contentEditable={false} className={`address-input l3`}></p>
                  <p contentEditable={false} className={`address-input l4`}>
                    Glasgow
                  </p>

                  <div className="flat-input-group">
                    <span>Flat </span>

                    <p
                      contentEditable={false}
                      className={`address-input f1`}
                    ></p>
                    <span>/</span>
                    <p
                      contentEditable={false}
                      className={`address-input f2`}
                    ></p>
                    <span></span>
                  </div> */}

                  <div className="postcode-input-group">
                    <input
                      id="jobLocationPostcode"
                      name="jobLocationPostcode"
                      type="text"
                      autoComplete="off"
                      value={formData?.jobLocationPostcode ?? ""}
                      onChange={inputHandler}
                      onBlur={saveInput}
                      className="postcode-input"
                      // onFocus={inputHandler}
                      // onBlur={inputHandler}
                    />

                    {/* <span>G </span>

                    <p
                      contentEditable={false}
                      className={`address-input p1`}
                    ></p>
                    <p
                      contentEditable={false}
                      className={`address-input p2`}
                    ></p> */}
                  </div>
                </div>
              </div>
            </div>

            <div className="access-details-group">
              <span className="access-header">Subcontractor Details</span>
              <div className="access-details-boxes">
                <div className="access-day">
                  <span>Invoice No.</span>
                  <div>
                    <p contentEditable={false} className={`d-input`}></p>
                  </div>
                </div>
                <div className="access-time">
                  <span>Sub Paid</span>
                  <div>
                    <p contentEditable={false} className={`d-input`}></p>
                  </div>
                </div>
                <div className="access-date">
                  <span>Date</span>
                  <div>
                    <div className="access-date-inputs">
                      <p contentEditable={false} className={`d-input`}></p>
                      <span>/</span>
                      <p contentEditable={false} className={`d-input`}></p>
                      <span>/</span>
                      <p contentEditable={false} className={`d-input`}>
                        {currentYear}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="tenant-info-group">
                <div className="tenant-no">
                  <p className="t-label">Subcont. fee:</p>
                  <p className="t-input" contentEditable={false}></p>
                </div>

                <div className="tenant-name">
                  <p className="t-label">HES fee (25%):</p>
                  <p className="t-input" contentEditable={false}></p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row-3">
          <div className="payment-info-group">
            <div className="payment-check-boxes">
              <div className="payment-input-overlay">
                <input
                  name="paymentMethod"
                  type="radio"
                  value="paypal"
                  className="paypal-pay"
                  checked={formData.paymentMethod === "paypal"}
                  onChange={saveInput}
                  id="paypal"
                />
                <input
                  type="radio"
                  name="paymentMethod"
                  value="cheque"
                  className="cheque-pay"
                  checked={formData.paymentMethod === "cheque"}
                  onChange={saveInput}
                  id="cheque"
                />
                <input
                  type="radio"
                  name="paymentMethod"
                  className="cash-pay"
                  checked={formData.paymentMethod === "cash"}
                  value="cash"
                  onChange={saveInput}
                  id="cash"
                />
                <input
                  type="radio"
                  name="paymentMethod"
                  className="card-pay"
                  checked={formData.paymentMethod === "card"}
                  value="card"
                  onChange={saveInput}
                  id="card"
                />
                <input
                  type="radio"
                  name="paymentMethod"
                  className="online-pay"
                  checked={formData.paymentMethod === "online"}
                  value="online"
                  onChange={saveInput}
                  id="online"
                />
                <input
                  type="checkbox"
                  name="sent"
                  className="sent-invoice-checkbox"
                  checked={formData?.sent || false}
                  onChange={saveInput}
                  id="sent-invoice-checkbox"
                />
                <button
                  type="radio"
                  name="paymentMethod"
                  className="reset-pay"
                  value=""
                  onClick={saveInput}
                  id="reset-pay"
                >
                  x
                </button>
              </div>

              <div className="c-box">
                <span className="c-label">Paypal</span>
                <div className="c-square"></div>
              </div>
              <div className="c-box">
                <span className="c-label">Cheque</span>
                <div className="c-square"></div>
              </div>
              <div className="c-box">
                <span className="c-label">Cash</span>
                <div className="c-square"></div>
              </div>
              <div className="c-box">
                <span className="c-label">Card</span>
                <div className="c-square"></div>
              </div>
              <div className="c-box">
                <span className="c-label">Card fee</span>
                <div className="c-square">
                  <span className="card-fee-text">{calculateCardFee()}</span>
                </div>
              </div>
            </div>
            <span className="payment-label">Payment Method</span>
            <div className="online-box">
              <span className="check-label">Online</span>
              <div className="check-square"></div>
            </div>

            <div className="to-email-group">
              <span>to email</span>
              <input
                id="email"
                name="email"
                autoComplete="off"
                type="text"
                value={formData?.email ?? ""}
                onChange={inputHandler}
                onBlur={saveInput}
                className="to-email-input"
                // onFocus={inputHandler}
                // onBlur={inputHandler}
              />
              {/* <p contentEditable={false} className="to-email-input"></p> */}
            </div>

            <div className="invoice-sent-group">
              <span className="check-label">Invoice sent</span>
              <div className="check-square"></div>
            </div>

            <div className="day-group">
              <span>day</span>
              <p contentEditable={false} className="day-input"></p>
            </div>

            <div className="date-group">
              <span>date</span>
              <p contentEditable={false} className="date-input"></p>
              <span>/</span>
              <p contentEditable={false} className="date-input"></p>
              <span>/</span>
              <p contentEditable={false} className="date-input">
                {currentYear}
              </p>
            </div>
          </div>

          <div className="paid-group">
            <div className="p-line-1">
              <div className="paid-received-group">
                <p className="received-label">Payment Received Date</p>
                <div className="received-date-inputs">
                  <p contentEditable={false} className="date-input"></p>
                  <span>/</span>
                  <p contentEditable={false} className="date-input"></p>
                  <span>/</span>
                  <p contentEditable={false} className="date-input">
                    {currentYear}
                  </p>
                </div>
              </div>

              <div className="p-line-2">
                <div className="payment-confirmed">
                  <p className="confirmed-label">Payment Confirmed</p>
                </div>

                <div className="p-column">
                  <div className="payment-amount">
                    <span className="currency">£</span>
                    <p contentEditable={false} className="payment-amount-input"></p>
                    {/* <span className="amount-label">Amount</span> */}
                  </div>
                  <div className="payment-check-box">
                    <span className="payment-paid-label">PAID</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /////////////////////////////////////////////////////////////// */}

      {/* /////////////////////////////////////////////////////////////// */}

      {/* /////////////////////////////////////////////////////////////// */}

      {/* /////////////////////////////////////////////////////////////// */}

      {/* /////////////////////////////////////////////////////////////// */}

      {/* /////////////////////////////////////////////////////////////// */}

      {/* /////////////////////////////////////////////////////////////// */}

      {/* /////////////////////////////////////////////////////////////// */}

      <div className="jobsheetViewPage2">
        <div className="row-1">
          <h2>
            Timesheet <span>{"&"}</span> Materials
          </h2>
          <div className="ref-numbers">
            <div className="hes-ref">
              <p>HES No</p>
              <div>
                <input type="text" />
              </div>
            </div>
            <div className="qte-ref">
              <div className="custom-border"></div>
              <div className="col-1">
                <p>SRN</p>
                <div>
                  <input type="text" />
                  <span>/ INIT / 00</span>
                </div>
              </div>

              <div className="col-2">
                <p>£</p>
                <div>
                  <input type="text" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="job-dates">
          <div className="job-start-dates">
            <p>Job Start Date</p>
            <div className="date-input">
              <input type="text" />
              <span>/</span>
              <input type="text" />
              <span>/</span>
              <span>{currentYear}</span>
            </div>
          </div>
          <div className="job-finish-dates">
            <p>Finish Date</p>
            <div className="date-input">
              <input type="text" />
              <span>/</span>
              <input type="text" />
              <span>/</span>
              <span>{currentYear}</span>
            </div>
          </div>
        </div>

        <div className="job-desc-row">
          <div className="underlines">
            {underlines.map((u, i) => (
              <span key={i}></span>
            ))}
          </div>
          <div className="j-col col-1">
            <p className="job-row-heading">Job Description</p>
            <div className="col-space">
              {jds.map((jd, i) => {
                return (
                  <div key={i} className="jd">
                    <p className="date">{jd.date}</p>
                    <p className="desc">{jd.desc}</p>
                  </div>
                );
              })}
            </div>
          </div>

          <div className="j-col col-2">
            <p className="job-row-heading">Hours</p>
            <div className="col-space"></div>
          </div>

          <div className="j-col col-3">
            <p className="job-row-heading">Materials</p>
            <div className="col-space"></div>
          </div>

          <div className="j-col col-4">
            <p className="job-row-heading">Qty</p>
            <div className="col-space"></div>
          </div>

          <div className="j-col col-5">
            <p className="job-row-heading">Cost</p>
            <div className="col-space"></div>
          </div>
        </div>

        <div className="last-row">
          <div className="total-hours">
            <p>Total Hours:</p>
            <div className="box-space"></div>
          </div>

          <div className="total-materials">
            <div className="box-space"></div>
          </div>

          <div className="sub-total">
            <p>Sub Total:</p>
            <div className="box-space"></div>
          </div>

          <div className="total">
            <p>TOTAL:</p>
            <div className="box-space"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default JobsheetView;
